import { defineComponent as _defineComponent } from 'vue'
import CollateralRawAmounts from 'ah-trades/src/components/collaterals/CollateralRawAmounts.vue';
import CollateralMargins from 'ah-trades/src/components/collaterals/CollateralMargins.vue';
import CollateralActions from 'ah-trades/src/components/collaterals/CollateralActions.vue';
import CollateralActionsHelpText from 'ah-trades/src/components/collaterals/CollateralActionsHelpText.vue';
import WarningChangesBanner from '@/app/components/trades/WarningChangesBanner.vue';
import { Client } from 'ah-api-gateways';
import debounce from 'lodash/debounce';
import { DebouncedFunc } from 'lodash';
import OnBehalfOf from 'ah-common-lib/src/onBehalfOf/OnBehalfOf';
import { CollateralActionEvent } from 'ah-trades/src/components/collaterals/CollateralActionEvent';
import { DEFAULT_INACTIVITY_TIMEOUT } from 'ah-common-lib/src/constants/time';
import { useAuthStore } from '@/app/store/authStore';
import { useWalletsStore } from '@/app/store/walletsModule';
import { computed, onBeforeMount, onMounted, onUnmounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { getServices } from '@/app/services';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useToast } from 'ah-common-lib/src/toast';

/**
 * On behalf of client collateral management
 *
 * If set, partner can access the client collateral management
 * on behalf of client with ID 'clientId'
 *
 * FIXME: debouncedLoad is a patch to allow wallet refresh to bypass race condition
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'CollateralManagementView',
  props: { clientId: { type: String, required: false } },
  setup(__props) {

const props = __props;

const walletStore = useWalletsStore();

const router = useRouter();

const route = useRoute();

const services = getServices();

const requestManager = useRequestManager().manager;

const toast = useToast();

const authStore = useAuthStore();



const onBehalfOfClient = ref<Client>();

const debouncedLoad = ref<DebouncedFunc<() => void>>();

const refreshComponentTimeout = ref<number>();

onMounted(() => refreshComponent());

onBeforeMount(() => {
  loadCollaterals();
  debouncedLoad.value = debounce(() => loadCollaterals(), 3000);
});

function refreshComponent() {
  if (refreshComponentTimeout.value) {
    refreshComponentTimeout.value = window.setInterval(() => {
      loadCollaterals();
    }, DEFAULT_INACTIVITY_TIMEOUT);
  }
}

onUnmounted(() => {
  debouncedLoad.value!.cancel();
  if (refreshComponentTimeout.value !== null) clearInterval(refreshComponentTimeout.value);
});

function goBack() {
  router.push('/admin/activity/clients/obo/' + props.clientId);
}

function reloadData() {
  getOBOClient();
  loadCollaterals();
}

function getOBOClient() {
  if (props.clientId) {
    requestManager.currentOrNew('loadClient', services.client.getClient(props.clientId)).subscribe((response) => {
      onBehalfOfClient.value = response;
    });
  }
}

watch(() => props.clientId, getOBOClient, { immediate: true });

function onCollateralAction(event: CollateralActionEvent) {
  toast.success(`${event.mode === 'post' ? 'Posted to' : 'Withdrew from'} collaterals successfully.`);
  debouncedLoad.value!();
}

function loadCollaterals() {
  return requestManager.newPromise(
    'loadCollaterals',
    walletStore.loadCollaterals({ force: true, clientId: props.clientId })
  );
}

const isAgent = computed(() => authStore.isAgent);
const readonly = computed(() => route.meta?.readonly || false);
const isOBOAction = computed(() => !!(!readonly.value && isAgent && onBehalfOfClient.value));
const isClientUser = computed(() => authStore.isClientUser);

return { __sfc: true,walletStore, router, route, services, requestManager, toast, authStore, props, onBehalfOfClient, debouncedLoad, refreshComponentTimeout, refreshComponent, goBack, reloadData, getOBOClient, onCollateralAction, loadCollaterals, isAgent, readonly, isOBOAction, isClientUser, CollateralRawAmounts, CollateralMargins, CollateralActions, CollateralActionsHelpText, WarningChangesBanner, OnBehalfOf }
}

})